const digitalTechnologiesAtTheStageOfPatientCommunicationRu = `
      <p>
        На сегодняшний день существует проблема, связанная с коммуникацией врачей стоматологов и пациентов на этапе
        консультации. Проблема связана с тем, что появилось очень много сложных методов реабилитации пациентов.
      </p>
      <p>
        Докторам теперь необходимо не только правильно диагностировать стоматологическую патологию, но и донести
        пациенту все возможные и актуальные пути решения этой проблемы путём наглядной визуализации. Для этого доктора
        продолжают использовать неактуальные и неэффективные методы, например, бумагу и ручку.
      </p>
      <p>
        В эпоху интернета пациенты самостоятельно ищут пути решения своей проблемы в сети, затем собирают и
        подготавливают для своих лечащих врачей информацию, которая, по их мнению, поможет наилучшим образом решить
        проблему.
      </p>
      <p>
        В такой ситуации стоматологам просто необходима программа, позволяющая наглядно визуализировать и доходчиво
        аргументировать пациентам свои доводы в разговорах с пациентами. Врачам стоматологам необходима программа,
        которая поможет убедить пациентов выбрать предлагаемый ими наиболее надёжный и качественный план лечения.
        Десктоп приложение для мотивации пациентов — Dental Bot идеально справится с этой задачей.
      </p>
      <h2>Нужна ли цифра на этапе консультации пациента?</h2>
      <p>
        На сегодняшний день цифра – это БРЕНД. Ежегодно количество стоматологических компаний, которые позиционируют
        себя как цифровые клиники только увеличивается.
      </p>
      <p>
        Цифровые технологии в стоматологии уже стали неотъемлемой частью всех технологических процессов. Врачи получают
        оттиски при помощи интраорального сканирования. Сбор результатов рентгеновских исследований, хранение
        медицинских данных пациентов и планирование реабилитации пациентов выполняется при помощи цифровых технологий.
        Администрирование и планирование приема пациентов также происходят в цифре.
      </p>
      <p>
        Цифровые технологии в стоматологии полезно внедрить и на этапе консультации с пациентом. Данный подход поможет
        подчеркнуть высокую технологичность и премиальность стоматологической компании.
      </p>
      <h2>Что цифра может дать на этапе коммуникации с пациентом?</h2>
      <p>Внедрение цифровых технологий обеспечивает врачам и стоматологическим клиникам:</p>
      <p>
        - имиджевый и высокотехнологичный подход к консультации пациентов и дальнейшей работе с ними;
        <br /> - сокращение времени приёма пациентов (за счёт самостоятельной работы пациента с информационно-обучающей
        панелью);
        <br /> - возможность просмотра всех конструкций в деталях, а также визуализацию конечного результата
        реабилитации пациентов ещё до её начала;
        <br /> - улучшение коммуникации между пациентами и врачами;
        <br /> - улучшение бизнес процессов (обучение молодых сотрудников, оптимизация времени приема каждого пациента,
        движение в сторону онлайн консультаций и телемедицины, администрирование и управление персоналом);
        <br /> - предварительную онлайн консультацию пациентов.
      </p>
      <h2>Что доктора ждут от цифры на этапе коммуникации с пациентом?</h2>
      <p>
        Специалисты компании Colleagial Studio провели опрос среди топовых специалистов в области стоматологии и пришли
        к мнению, что любая современная стоматологическая клиника нуждается в:
      </p>
      <p>
        - приложении, которое позволит визуализировать клинические случаи и актуальных методах решений;
        <br /> - применении мотивационного контента для выбора более практичной и надежной конструкции;
        <br /> - возможности предоставлять стоматологическое приложение для пациентов, в котором посетители клиники
        смогут самостоятельно изучить свою проблему во время ожидания приёма у стоматолога;
        <br /> - базе аргументов для докторов, которая позволила бы им убеждать пациентов выбирать более надёжные и
        практичные методы лечения;
        <br /> - создании документов с описанием плана лечения в режиме онлайн;
        <br /> - возможности онлайн просмотра плана реабилитации в 3D пациентами вне клиники вместе с родными и
        близкими.
      </p>
      <h2>Решение проблемы</h2>
      <p>
        Собрав и изучив выше изложенную информацию, команда Colleagial Studio разработала уникальное десктоп приложение
        для мотивации пациентов— Dental Bot 3D.
      </p>
      <p>
        Уникальность данной программы заключается в 3D формуле, которая позволяет визуализировать в пространстве любые
        клинические случаи, а также все основные современные методики реабилитации пациентов при адентии или нарушении
        эстетики.
      </p>
      <p>
        Данное приложение имеет инструктивно понятный и простой интерфейс, который позволяет пациентам работать с
        программой самостоятельно. Для этого дополнительно разработаны подсказки и обучающий видео контент.
      </p>
      <h2>Dental Bot 3D – инструмент для улучшения бизнеса.</h2>
      <p>Dental Bot 3D – это высокотехнологичный инструмент для продажи планов лечения.</p>
      <p>
        Владельцы стоматологического бизнеса, которые выбрали приложение Dental Bot 3D, обладают прекрасной возможностью
        выделить свою клинику среди других.
      </p>
      <p>
        Dental Bot 3D также является огромной аргументной базой для стоматологов, помогающей обосновывать свои решения
        пациентам. Применяя десктоп приложение для мотивации пациентов — Dental Bot 3D, врачи могут незаметно для пациентов
        подталкивать их к совершению оптимального выбора, сохраняя при этом уверенность пациентов в том, что они приняли
        решение самостоятельно.
      </p>
      <p>
        Ещё система Dental Bot 3D будет полезна в обучении молодых специалистов стоматологических клиник. Используя
        приложение, они научатся быстрее работать и продавать планы лечения более профессионально.
      </p>
      <p>
        Dental Bot 3D позволит выработать единый протокол консультации пациентов в клинике. Это в свою очередь позволит
        улучшить бизнес процессы компании.
      </p>
      <h2>Основная идея использования Dental Bot 3D.</h2>
      <p>
        Приложение рассчитано минимум на два устройства. Это могут быть планшет в приёмной и монитор в кабинете у
        доктора.
      </p>
      <p>
        Первое знакомство пациента с программой может происходить в приёмной врача стоматолога, где ему предложат
        планшет с приложением. Далее пациент получит возможность самостоятельно изучить свою стоматологическую проблему
        и найти пути её решения.
      </p>
      <p>
        Зайдя в кабинет к доктору, пациент будет более подготовленным и благодаря этому можно считать, что он начал
        консультацию самостоятельно. Врач, в свою очередь, изучив сохраненные пациентом данные, сможет лучше понять
        проблему и провести консультацию более эффективно. Такой подход поможет доктору максимально сократить время
        приема пациентов и провести больше консультаций.
      </p>
      <p>
        Мир современной стоматологии нуждается в цифровых инструментах консультации пациентов и презентации планов
        лечения. Цифровые технологии способны обеспечить качественный, и даже премиальный подход к работе с пациентом.
        Стоматологическому бизнесу нужна цифры на этапе коммуникации с пациентом для полной диджитализации процессов в
        клинике.
      </p>
      <p>
        Рынок цифровых стоматологических продуктов способен предложить качественные и зрелые решения. Система Dental Bot 3D
        очень выгодно смотрится на этом рынке и имеет все шансы покорить как современные клиники, так и стоматологии
        будущего. Наша команда динамично развивает приложение и работает над расширением уже имеющегося функционала.
      </p>
`;

export default digitalTechnologiesAtTheStageOfPatientCommunicationRu;
